import type { MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Returns a factory for onClick handlers for clickable table rows that supports:
 * - Normal click: navigates in-app using react-router
 * - Cmd+Click / Ctrl+Click: opens the path in a new browser tab
 *
 * Handles both absolute paths (/some/path) and relative paths (./id or just id).
 *
 * Usage:
 *   const onRowClick = useRowClick();
 *   <TableRow onClick={onRowClick('/some/path')}>
 */
export function useRowClick() {
    const navigate = useNavigate();
    return (path: string) => (e: MouseEvent) => {
        if (e.metaKey || e.ctrlKey) {
            window.open(new URL(path, window.location.href).href, '_blank');
        } else {
            navigate(path);
        }
    };
}
